module.exports = "<!-- the navbar selector is the wrapper of content -->\r\n<router-outlet></router-outlet>\r\n\r\n<div *ngIf=\"loading\">\r\n      <app-loading-page></app-loading-page>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main